import { QuestionnaireResponse, QuestionnaireResponseItem, QuestionnaireResponseItemAnswer } from '@medplum/fhirtypes';

/** Trim and collapse any run of whitespace to a single space (FHIR `code` disallows consecutive internal spaces). */
function normalizeSaveStrings(value: string): string {
  return value.trim().replace(/\s+/g, ' ');
}

function trimAnswer(answer: QuestionnaireResponseItemAnswer): QuestionnaireResponseItemAnswer {
  const next: QuestionnaireResponseItemAnswer = { ...answer };

  if (typeof next.valueString === 'string') {
    next.valueString = normalizeSaveStrings(next.valueString);
  }
  if (typeof next.valueUri === 'string') {
    next.valueUri = normalizeSaveStrings(next.valueUri);
  }

  if (next.valueCoding) {
    const c = next.valueCoding;
    next.valueCoding = {
      ...c,
      ...(typeof c.system === 'string' ? { system: normalizeSaveStrings(c.system) } : {}),
      ...(typeof c.code === 'string' ? { code: normalizeSaveStrings(c.code) } : {}),
      ...(typeof c.display === 'string' ? { display: normalizeSaveStrings(c.display) } : {}),
      ...(typeof c.version === 'string' ? { version: normalizeSaveStrings(c.version) } : {}),
    };
  }

  if (next.valueReference) {
    const ref = next.valueReference;
    next.valueReference = {
      ...ref,
      ...(typeof ref.reference === 'string' ? { reference: normalizeSaveStrings(ref.reference) } : {}),
      ...(typeof ref.display === 'string' ? { display: normalizeSaveStrings(ref.display) } : {}),
    };
  }

  if (next.valueQuantity) {
    const q = next.valueQuantity;
    next.valueQuantity = {
      ...q,
      ...(typeof q.unit === 'string' ? { unit: normalizeSaveStrings(q.unit) } : {}),
      ...(typeof q.code === 'string' ? { code: normalizeSaveStrings(q.code) } : {}),
      ...(typeof q.system === 'string' ? { system: normalizeSaveStrings(q.system) } : {}),
    };
  }

  return next;
}

function trimItem(item: QuestionnaireResponseItem): QuestionnaireResponseItem {
  return {
    ...item,
    ...(item.answer ? { answer: item.answer.map(trimAnswer) } : {}),
    ...(item.item ? { item: item.item.map(trimItem) } : {}),
  };
}

/**
 * Returns a shallow copy of the response with string-like answers normalized for save: trim,
 * then collapse repeated whitespace to a single space (helps FHIR `code` and similar fields).
 */
export function trimQuestionnaireResponseForSave(response: QuestionnaireResponse): QuestionnaireResponse {
  return {
    ...response,
    ...(response.item ? { item: response.item.map(trimItem) } : {}),
  };
}
